import type { BridgeMessageHandler } from '../message-router.js';
import { deploySessionToPreviewEnvironment } from '../../worktrees/deploy/deploy-session-to-preview-environment.js';
import { sendDeploySessionToPreviewResult } from './send-deploy-session-to-preview-result.js';

export const handleDeploySessionToPreviewMessage: BridgeMessageHandler<'deploy_session_to_preview'> = (
  msg,
  deps,
) => {
  if (typeof msg.id !== 'string') return;
  const sessionId = typeof msg.sessionId === 'string' ? msg.sessionId : '';
  const environmentId = typeof msg.environmentId === 'string' ? msg.environmentId : '';
  if (!sessionId || !environmentId) return;

  void (async () => {
    const ws = deps.getWs();
    const reply = (payload: {
      ok?: boolean;
      error?: string;
      deployBranch?: string;
      previewParentPath?: string;
    }) => sendDeploySessionToPreviewResult(ws, msg.id as string, payload);

    try {
      if (!deps.previewWorktreeManager) {
        reply({ ok: false, error: 'Preview worktree manager unavailable' });
        return;
      }
      const result = await deploySessionToPreviewEnvironment({
        sessionWorktreeManager: deps.sessionWorktreeManager,
        previewWorktreeManager: deps.previewWorktreeManager,
        sessionId,
        environmentId,
        log: deps.log,
      });
      reply(result);
    } catch (e) {
      reply({ ok: false, error: e instanceof Error ? e.message : String(e) });
    }
  })();
};
